import React from "react";
import AntdTypography, {TypographyProps} from "antd/lib/typography";
import {withError} from '@fishx/tracker';

const Text = AntdTypography.Text;
const Title = AntdTypography.Title;
const Paragraph = AntdTypography.Paragraph;

interface FCTypographyProps extends React.FC<TypographyProps> {
   Text: typeof Text;
   Title: typeof Title;
   Paragraph: typeof Paragraph;
}

const Typography: FCTypographyProps = (props) => {
  const { children } = props;
  return <AntdTypography {...props}>{children}</AntdTypography>;
}
Typography.Text = Text;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
Typography.displayName = 'Typography';
export default withError(Typography);



// WEBPACK FOOTER //
// ./src/components/typography/index.tsx